module.exports = __webpack_public_path__ + "img/921_page_background_people5_pc.058964e2.jpg";